import * as React from 'react'
import './CustomUI.scss';
import { IDesignerMode } from '../../designer/core/designer-types';
import { IBaseInputFieldProperty, IPropertyEditorProps, IUIPropertyDefinition, IWidgetMode, PropertyPath } from '../common';
import { Property, PropertyContainer, PropertyGroup, PropertyGroupTitle, PropertyTitle } from '../ui-props/common';
import { FieldProperty, IFieldTitleProps } from '../components/FieldTitle';
import { Input, TextArea } from 'uxp/components';
import { IDataSource, IDataSourceBinding } from '../data-source-picker/datasource';
import { DataSourcePropertyEditor } from '../ui-props/DataSourceProperty';
export interface ICustomUIDefinition {
    web: string;
    mobile: string;

}
export interface ICustomUIProps extends ICustomUIDefinition {
    mode?: IWidgetMode;
}
interface ICustomUIProperty extends ICustomUIDefinition {

}
export interface ICustomUIFieldProperty extends IBaseInputFieldProperty, ICustomUIDefinition {

    fieldLabel?: IFieldTitleProps;
    binding: IDataSourceBinding;
}


export function CustomUIProperty(title: string, props: ICustomUIProperty, datasourcesPath: PropertyPath): IUIPropertyDefinition<ICustomUIFieldProperty> {
    return {
        defaults: { web: '', mobile: '', binding: null, },
        render: (props, uxpContext, data, containerId, customProps) => {
            const datasources = customProps?.datasources || []

            return <CustomUIPropertyEditor {...props} isNotField={true} datasourcesPath={datasourcesPath} datasources={datasources} />
        }
    };
}



export const CustomUIPropertyEditor: React.FunctionComponent<IPropertyEditorProps<ICustomUIFieldProperty> & { isNotField?: boolean, datasourcesPath?: PropertyPath, datasources?: IDataSource[] }> = (props) => {

    return <PropertyContainer>
        <PropertyGroup>
            <PropertyGroupTitle>Custom UI</PropertyGroupTitle>
            {
                (props.isNotField != true) &&
                <FieldProperty uiProps={props.uiProps} onChange={props.onChange} />

            }
            <Property>
                <PropertyTitle>Custom UI (Mobile)</PropertyTitle>
                <TextArea
                    value={props.uiProps.mobile}
                    onChange={s => {
                        props.onChange({ web: props.uiProps.web, mobile: s, binding: props.uiProps.binding });
                    }}
                />
                {/* <textarea value={(props.uiProps.mobile)} onChange={(e) => {
                            props.onChange({ web: props.uiProps.web, mobile: e.target.value });
                        }} /> */}
            </Property>
            <Property>
                <PropertyTitle>Custom UI (Web)</PropertyTitle>
                {/* <textarea value={(props.uiProps.web)} onChange={(e) => {
                    props.onChange({ mobile: props.uiProps.mobile, web: e.target.value });
                }} /> */}
                <TextArea
                    value={props.uiProps.web}
                    onChange={s => {
                        props.onChange({ mobile: props.uiProps.mobile, web: s, binding: props.uiProps.binding });
                    }}
                />
            </Property>

        </PropertyGroup>
        <PropertyGroup>
            <PropertyGroupTitle>Data Source</PropertyGroupTitle>
            <Property>
                <DataSourcePropertyEditor
                    binding={props.uiProps.binding}
                    context={props.uxpContext}
                    onChange={(binding) => props.onChange(Object.assign({}, props.uiProps, { binding }))}
                    onChangeAny={(p, v) => {
                        if (!!props.datasourcesPath) p = props.datasourcesPath
                        props.onChangeAny(p, v);
                    }}
                    sources={props.datasources || []}
                    target={'any'}
                    title='Data Source'
                    contextData={props.contextData}
                    className='uxp-designer-data-source-selector'
                    designer={props.designer}
                />
            </Property>
        </PropertyGroup>

    </PropertyContainer>;
}


export const CustomUI: React.FunctionComponent<ICustomUIProps> = (props) => {
    let { web, mobile } = props;
    let isDesign = props.mode == 'preview' || props.mode == 'thumbnail';
    return <div className='wd-custom-ui-component'>
        {
            (web || !isDesign) && <div className="data-area-container-wrapper-web" dangerouslySetInnerHTML={{ __html: web || '' }} />
        }
        {
            ((isDesign && !web)) && <div className="data-area-container-wrapper" >Custom UI</div>
        }
    </div>
}